import React, { MouseEventHandler, ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';
import { faCloudDownload } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { TABLET_PORTRAIT } from '@tovia/man-ui';

type Props = {
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
};

export const DownloadButton = (props: Props) => {
  return (
    <OwnItNowButton id="own-it-now" className={cx(props.className, 'btn')} onClick={props.onClick}>
      <DownloadIconWrapper>
        <FontAwesomeIcon icon={faCloudDownload} />
      </DownloadIconWrapper>
      <Label>{props.children}</Label>
      <Caret />
    </OwnItNowButton>
  );
};

const OwnItNowButton = styled.button`
  font-size: 2.6rem;
  position: relative;
  padding: 0;
  text-align: center;
  margin: 5px auto;
  transition: opacity 0.3s;
  border-color: #be8c31;
  background-color: #f9d083;
  color: #645434;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${TABLET_PORTRAIT} {
    font-size: 2.2rem;
  }
`;

export const DownloadIconWrapper = styled.div`
  background: rgba(255, 255, 255, 0.3);
  color: #000;
  height: 100%;
  padding: 10px 16px;
`;

const Caret = styled(FontAwesomeIcon).attrs({
  icon: faCaretDown,
})`
  font-size: 85%;
  margin: 0 16px;
`;

const Label = styled.span`
  padding: 0 16px;
`;
